import { Name, NameLink } from './AuthorNameLink.styles';

export interface AuthorNameLinkProps {
  className?: string;

  name: string | undefined | null;
  route?: string;
  disabled?: boolean;
}

export function AuthorNameLink(props: AuthorNameLinkProps) {
  const name = props.name ?? '';

  if (props.route && !props.disabled) {
    return (
      <NameLink title={name} className={props.className} to={props.route}>
        {name}
      </NameLink>
    );
  }

  return (
    <Name className={props.className} title={name}>
      {name}
    </Name>
  );
}
